import { render, staticRenderFns } from "./WbBar.vue?vue&type=template&id=51a8ad53&scoped=true"
import script from "./WbBar.vue?vue&type=script&lang=js"
export * from "./WbBar.vue?vue&type=script&lang=js"
import style0 from "./WbBar.vue?vue&type=style&index=0&id=51a8ad53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8ad53",
  null
  
)

export default component.exports